import type { FC } from "react";
import { Box, Stack, SvgIcon } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
interface WarningMessageProps {
  text: string;
}

export const WarningMessage: FC<WarningMessageProps> = ({ text }) => {
  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={1}
      >
        <SvgIcon color="warning">
          <WarningIcon />
        </SvgIcon>
        <Box>{text}</Box>
      </Stack>
    </>
  );
};
